import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function About() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <p className="eyebrow text-ink/60 enter">About</p>
      <h1 className="font-display font-extrabold text-4xl sm:text-5xl display-tight uppercase mt-3 enter" style={{ animationDelay: "60ms" }}>
        Look what AI is doing to business.
      </h1>
      <div className="mt-8 space-y-6 text-lg text-ink/80 leading-relaxed">
        <p>
          AI YAI YAI is a global discovery platform showing real examples of businesses materially transformed by AI —
          not an AI news site, not a tools directory, not an idea generator.
        </p>
        <div className="bg-brlime border-2 border-ink p-6">
          <p className="font-display font-bold text-ink text-xl leading-snug">
            We only feature cases where AI materially changed a process, product, service or business model —
            not simply where someone started using an AI tool.
          </p>
        </div>
        <p>
          <strong>Evidence first.</strong> We distinguish between source facts and AI YAI YAI editorial interpretation. We never
          invent results, and we never imply independent verification where a claim was only reported by a company or vendor —
          so you'll see wording like <em>“€250,000 reported saving”</em> rather than <em>“€250,000 saving.”</em> Every case keeps its original source URL.
        </p>
        <p>
          We favour credible sources: vendor customer stories (Microsoft, Google, AWS, OpenAI and others), detailed accounts from the
          businesses themselves, and reputable business publications. We deliberately diversify across industries, company sizes and countries.
        </p>
        <p className="text-ink/60">
          The aim is simple: browse for five minutes and repeatedly think, <em>“I didn't know businesses were doing that with AI.”</em>
        </p>
      </div>
      <Link to="/" className="group btn-tactile mt-10 inline-flex items-center gap-2 bg-ink text-white font-bold px-6 h-12 hover:bg-cobalt">
        Start discovering <ArrowRight size={18} className="arrow-move" />
      </Link>
    </div>
  );
}
